import { render, staticRenderFns } from "./XmAddressShuttle.vue?vue&type=template&id=b116757a&scoped=true"
import script from "./XmAddressShuttle.vue?vue&type=script&lang=js"
export * from "./XmAddressShuttle.vue?vue&type=script&lang=js"
import style0 from "./XmAddressShuttle.vue?vue&type=style&index=0&id=b116757a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b116757a",
  null
  
)

export default component.exports